import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { STUDY_PLAN_METRICS_TRANSLATION_KEY } from "./constants";
export default {
  en: /*#__PURE__*/_defineProperty({}, STUDY_PLAN_METRICS_TRANSLATION_KEY, {
    STUDY_PLAN: 'Study Plan',
    EDIT_STUDY_PLAN: 'Edit Study Plan',
    EDIT_STUDY_PLAN_SHORT: 'Edit Plan',
    // Activity
    ACTIVITY_TITLE: 'Your Activity in Classes',
    MINUTE_COUNT: '{{minutes}} min',
    CURRENT_WEEK: 'Week of {{startDate}} - {{endDate}}',
    ACTIVITY_EMPTY_LABEL: "It's time to go to class! Have a great start to the week to reach your weekly goal ⏰",
    ACTIVITY_EMPTY_3_DAYS_LABEL: 'Everything okay? No activity has been recorded in class this week 😢',
    ACTIVITY_IN_PROGRESS_LABEL: "You're on track! Keep it up and you'll reach your weekly goal 💪",
    ACTIVITY_ALMOST_COMPLETED_LABEL: "Great job! You're about to reach your weekly goal, keep up the good work 👏",
    ACTIVITY_COMPLETED_LABEL: "Great effort! You've successfully reached your weekly goal 🎉",
    ACTIVITY_EXCEDED_LABEL: "Wow, what a great week you're having! You've successfully exceeded your weekly goal 🎉",
    WEEKLY_TARGET: 'Your weekly goal is {{minutes}} minutes',
    CHANGE_WEEKLY_TARGET: "If your weekly goal of {{minutes}} minutes isn't working, you can modify it ",
    CHANGE_WEEKLY_TARGET_CTA: 'here',
    // Progress
    PROGRESS_TITLE: 'Your Progress This Week',
    PROGRESS_EMPTY_LABEL: "You haven't recorded any activity this week. Don't fall behind!",
    PROGRESS_EMPTY_5_DAYS_LABEL: "You haven't recorded any activity this week. Take advantage of the weekend to finish your course.",
    PROGRESS_IN_PROGRESS_LABEL: 'You have accumulated **{{minutes}} minute** of activity so far.',
    PROGRESS_IN_PROGRESS_LABEL_plural: 'You have accumulated **{{minutes}} minutes** of activity so far.',
    PROGRESS_COMPLETED_LABEL: 'You are amazing! You have accumulated **{{minutes}} minute** of activity so far.',
    PROGRESS_COMPLETED_LABEL_plural: 'You are amazing! You have accumulated **{{minutes}} minutes** of activity so far.',
    // Empty view
    EMPTY_VIEW_TITLE: "It seems you haven't created your study plan yet",
    EMPTY_VIEW_DESC: 'We want to contribute to your professional growth in the best way possible. With a study plan, you can better organize yourself and achieve each of your goals at Crehana.',
    EMPTY_VIEW_BUTTON: 'Create my study plan',
    // Error
    STUDY_PLAN_ERROR: 'An error occurred while retrieving your study plan information',
    STUDY_PLAN_RETRY_BUTTON_LABEL: 'Retry'
  })
};